@use '../../styling/form-controls.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

$gutter: 6px;

.Fieldset {
  border: 0;
  padding: 0;
  margin: 0;

  >legend {
    @extend %form-control-label-font;

    margin-bottom: 8px;
    display: flex;
    padding: 0;
    align-items: center;

    >span:first-child {
      display: flex;
      width: 14px;
    }

    >h3 {
      padding: 0;
      margin-right: 5px;
    }

    .badgeWrapper {
      padding-left: 8px;
    }
  }

  &.hasBorderTop {
    >legend {
      border-top: 1px solid $theme-color-divider;
      padding-top: 32px;
      width: 100%;
      height: 24px;
      margin-bottom: 24px; // default header have padding top 10px
    }
  }

  &.noBorderTop {
    >legend {
      width: 100%;
      height: 24px;
      margin-bottom: 24px; // default header have padding top 10px
    }
  }

  >.FieldsetFlex {
    // <fieldset/> cannot be a flexbox https://bugzilla.mozilla.org/show_bug.cgi?id=1047590
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    box-sizing: border-box;

    >* {
      margin-bottom: 18px;
      flex-basis: auto;
      flex-grow: 1;
    }

    >fieldset {
      flex-basis: 100%; // full width
    }
  }

  >.FieldsetGrid {
    display: grid;
    row-gap: 18px;
    grid-auto-flow: row;
    grid-auto-columns: minmax(0, 1fr); // ensure the width allocation is not depending on child max width
  }

  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;
    background-color: $theme-color-sub-background;
  }

  &.hasPadding {
    margin: 0 -18px;
    padding: 0 $gutter * 2;

    >legend {
      margin-left: $gutter;
    }

    >.FieldsetFlex>* {
      padding-left: $gutter;
      padding-right: $gutter;
    }

    >.FieldsetGrid {
      margin: 0 $gutter;
      padding: 0.5em 0.75em 1em;
    }
  }

  &.hasBoundary {
    @extend %form-control-border;

    padding: 8px;

    .hasBoundary {
      margin: 5px; // Nested boundaries need space to prevent overlap
    }

    >legend {
      padding-left: 12px;
      padding-right: 24px;
      margin-bottom: 0;
    }
  }
}